"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultLanguage = void 0;
const defaultLanguage = exports.defaultLanguage = 'en';